// ============================================================================
// GESTIMMONY — Ressources côté client (/app/ressources)
// ============================================================================
// Reprend les articles publics (data/articles.js) dans l'espace connecté.
// Les articles s'ouvrent dans un nouvel onglet (/ressources/:slug) pour
// conserver le contexte de l'application.
// ============================================================================
import { ArrowRight, Clock, BookOpen } from "lucide-react";
import { ARTICLES } from "@/data/articles";

export default function AppResourcesPage() {
  return (
    <div className="space-y-6" data-testid="app-resources-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <BookOpen className="h-6 w-6 text-[hsl(var(--primary))]" /> Ressources &amp; guides
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Guides pratiques et fiscaux — révision IRL, déclaration 2044, charges récupérables — pour gérer vos locations sereinement.
        </p>
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {ARTICLES.map((a) => (
          <a
            key={a.slug}
            href={`/ressources/${a.slug}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`app-article-${a.slug}`}
            className="group flex flex-col rounded-2xl border border-slate-200 bg-white overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-all"
          >
            <div className="aspect-[16/10] overflow-hidden bg-slate-100">
              <img
                src={a.cover}
                alt={a.title}
                loading="lazy"
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex flex-col flex-1 p-5">
              <div className="flex items-center gap-3 text-xs text-slate-500 mb-2">
                <span className="font-medium text-teal-700">{a.category}</span>
                <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" /> {a.readTime}</span>
              </div>
              <h2 className="font-heading font-semibold text-slate-900 text-lg leading-snug group-hover:text-[hsl(var(--primary))] transition-colors">
                {a.title}
              </h2>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{a.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[hsl(var(--primary))]">
                Lire l'article <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
